import React from 'react';
import { useTranslation } from 'react-i18next'; // For translations
import chevron from '../assets/icons/chevron.svg'; // Adjust the path to your icon
import partners from '../assets/images/partners-logos.png'

function AboutUs() {
  const { t } = useTranslation(); // Hook for translation

  return (
    <div>
      {/* Hero Banner */}
      <div className="hero-banner">
        <div className="hero-content">
          <p>{t('about-us-par1')}</p>
        </div>
      </div>

      {/* Our Objectives Section */}
      <section className="objectives-section">
        <div className="container">
          <h2>{t('geosa_objectives')}</h2>
          <div className="objectives-grid">
            <div className="objective">
              <img src={chevron} alt="chevron" />
              <h3>{t('geosa_objectiv1')}</h3>
            </div>
            <div className="objective">
              <img src={chevron} alt="chevron" />
              <h3>{t('geosa_objectiv2')}</h3>
            </div>
            <div className="objective">
              <img src={chevron} alt="chevron" />
              <h3>{t('geosa_objectiv3')}</h3>
            </div>
            <div className="objective">
              <img src={chevron} alt="chevron" />
              <h3>{t('geosa_objectiv4')}</h3>
            </div>
            <div className="objective">
              <img src={chevron} alt="chevron" />
              <h3>{t('geosa_objectiv5')}</h3>
            </div>
            <div className="objective">
              <img src={chevron} alt="chevron" />
              <h3>{t('geosa_objectiv6')}</h3>
            </div>
            <div className="objective">
              <img src={chevron} alt="chevron" />
              <h3>{t('geosa_objectiv7')}</h3>
            </div>
          </div>
        </div>
      </section>

      {/* Our Initiatives Section */}
      <section className="vision-section">
        <div className="container">
          <h2>{t('geosa_initiatives')}</h2>
          <p>{t('geosa_initiative_subtitle')}</p>
          <div className="values-grid">
            <div className="value-box">
              <h3>{t('geosa_initiativ1')}</h3>
              <p>{t('geosa_initiativ1_sub')}</p>
            </div>
            <div className="value-box">
              <h3>{t('geosa_initiativ2')}</h3>
              <p>{t('geosa_initiativ2_sub')}</p>
            </div>
            <div className="value-box">
              <h3>{t('geosa_initiativ3')}</h3>
              <p>{t('geosa_initiativ3_sub')}</p>
            </div>
            <div className="value-box">
              <h3>{t('geosa_initiativ4')}</h3>
              <p>{t('geosa_initiativ4_sub')}</p>
            </div>
            <div className="value-box">
              <h3>{t('geosa_initiativ5')}</h3>
              <p>{t('geosa_initiativ5_sub')}</p>
            </div>
            <div className="value-box">
              <h3>{t('geosa_initiativ6')}</h3>
              <p>{t('geosa_initiativ6_sub')}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Geospatial Data Exchanging & Sharing Mechanism */}
      <section className="values-section">
        <div className="container">
          <h2 style={{ textAlign: 'center' }}>{t('geosa_datasharing')}</h2>
          <img
            src={t('diagram')} // Dynamically load the image from the JSON file
            alt="Geospatial Data Exchanging"
            style={{
              marginLeft: 'auto',
              marginRight: 'auto',
              width: '100%',
              display: 'block',
            }}
          />
        </div>
      </section>
      
            {/* Our Partners */}
      <section class="vision-section">
      <h2 data-key="our_partners">{t('our_partners')}</h2>
      <div class="carousel-container">
       
        <img
          class="carousel-img"
          src={partners}
          alt="Partner 1"
        />
        </div>
        </section>

            
    </div>
  );
}

export default AboutUs;
